import { render, staticRenderFns } from "./CompanyBindingDialog.vue?vue&type=template&id=1fa85173&scoped=true&"
import script from "./CompanyBindingDialog.vue?vue&type=script&lang=js&"
export * from "./CompanyBindingDialog.vue?vue&type=script&lang=js&"
import style0 from "./CompanyBindingDialog.vue?vue&type=style&index=0&id=1fa85173&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa85173",
  null
  
)

export default component.exports